import PropTypes from 'prop-types';

export const BusinessGroupsPropTypes = PropTypes.shape({
  businessGroup: PropTypes.string,
  description: PropTypes.string,
  active: PropTypes.bool,
});
